import * as angular from 'angular';
import { DistributionListService } from './DistributionListService';
export const distributionList = angular
    .module('distributionList', [])
    .service('DistributionListService', DistributionListService).name;
